import useSWR from "swr";
import { customNoAuthAxios } from "../../utils/customNoAuthAxios";


export const useSwrNoAuth = <T = any>(url: string | null) => {
  const fetcher = (url: string) => customNoAuthAxios.get(url).then(res => res.data);
  const { data, error, isLoading, isValidating } = useSWR<T>(url ? url : null, fetcher);
  return { data, error, isLoading, isValidating };
};